"use client";

import dynamic from "next/dynamic";
import { useTranslations } from "next-intl";
import { Loader2 } from "lucide-react";

const DraftRoomSkeleton = () => {
  const tUi = useTranslations("Ui");
  return (
  <div className="flex items-center justify-center min-h-[600px]">
    <div className="flex flex-col items-center gap-4">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      <p className="text-sm text-muted-foreground">{tUi("draftRoomDynamic.zagruzkaDraftKomnaty")}</p>
    </div>
  </div>
);
};

export const DraftRoom = dynamic(
  () => import("./draft-room").then((mod) => mod.default),
  {
    loading: DraftRoomSkeleton,
    ssr: false,
  },
);
